module.exports = __webpack_public_path__ + "img/placeholder.7dff3fb7.jpg";